import React from 'react'
import {  Row, Col } from 'react-bootstrap'
import {Nav  } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { Container, ListGroup, Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'


const isExternal = (href = '') => href.startsWith('http')
const isRoute = (href = '') => href.startsWith('/')

const urls = {
  githubOrg: 'https://github.com/pixagan',
  laeyerz: 'https://laeyerz.com',
  laeyerzGithub: 'https://github.com/pixagan/Laeyerz',
  laeyerzDocs: 'https://laeyerz.com',
  doqlets: '/doqlets',
  doqletsGithub: 'https://github.com/pixagan/doqlets',
  learn: '/learn',
  ragLearn: 'https://youtu.be/z-lXaIow93A?si=cFSI_PXk6uVT4j3h',
  about: '/about',
  docs: '#todo-documentation-url',
  examplesGithub: 'https://github.com/pixagan/laeyerz-examples',
  contact: '/contact',
  privacy: '/privacypolicy',
  terms: '/termsandconditions',
}

const FooterColumn = ({ title, links }) => (
  <Col sm={6} lg={3}>
    <h5 className='fw-bold mb-3' style={{ color: '#fff' }}>{title}</h5>
    {links.map((link) => isRoute(link.href) ? (
      <Link key={link.label} to={link.href} className='d-block mb-2 text-decoration-none' style={{ color: '#cfd2e5' }}>{link.label}</Link>
    ) : (
      <a key={link.label} href={link.href} target={isExternal(link.href) ? '_blank' : undefined} rel={isExternal(link.href) ? 'noreferrer' : undefined} className='d-block mb-2 text-decoration-none' style={{ color: '#cfd2e5' }}>{link.label}</a>
    ))}
  </Col>
)


const Footer = () => {
    return (

        <>
        
       <footer style={{ background: '#5b5c75ff', color: '#cfd2e5', padding: '56px 0 28px' }}>
    <Container>
      <Row className='g-4'>
        <FooterColumn title='Pixagan' links={[{ label: 'About', href: '/#about' }, { label: 'Technologies', href: '/#technologies' }, { label: 'Learn', href: urls.learn }]} />
        <FooterColumn title='Technologies' links={[{ label: 'Laeyerz', href: urls.laeyerz }, { label: 'Doqlets', href: urls.doqlets }, { label: 'Examples', href: '/#examples' }]} />
        <FooterColumn title='Developer' links={[{ label: 'GitHub', href: urls.githubOrg }, 
        //{ label: 'Documentation', href: urls.docs }
        ]} />
        <FooterColumn title='Additional' links={[{ label: 'Contact: biz@pixagan.com', href: '/' }, { label: 'Privacy', href: urls.privacy }, { label: 'Terms', href: urls.terms }]} />
      </Row>
      <div className='mt-5 pt-4 d-flex justify-content-between flex-wrap gap-3' style={{ borderTop: '1px solid rgba(255,255,255,0.12)' }}>
        <strong style={{ color: '#fff' }}>Pixagan.AI</strong>
         <span>biz@pixagan.com</span>
        <span>© Pixagan.AI</span>
      </div>
    </Container>
  </footer>
        
        </>


        )
    }
    
    export default Footer